module.exports = __webpack_public_path__ + "nc_static/media/deviceSoftware.d12222f9.svg";